import { LOCAL_STORE_JWT } from "~/utils/main";
import { getAuthHeader } from "~/utils/headers";

const base = `//www.dreamchimney.com/api`;

export const urlGenre = base + "/tracks/genre";

export const getGenre = (axios, genreId) => axios.get(`${urlGenre}/${genreId}`);
export const getGenrePopular = (axios, genreId) => axios.get(`${urlGenre}/${genreId}/popular`);
export const getGenreTracks = (axios, genreId, page = 1) => axios.get(`${urlGenre}/${genreId}/tracks?page=${page}`);

export const getGenreIsFavorite = (axios, genreId) =>
  axios.post(`${urlGenre}/${genreId}/is_favorite`, { jwt: localStorage.getItem(LOCAL_STORE_JWT) || false });
export const getGenreSetFavorite = (axios, genreId, jwtPayload = false) =>
  axios.post(`${urlGenre}/${genreId}/favorite`, { jwt: jwtPayload ? jwtPayload : localStorage.getItem(LOCAL_STORE_JWT) || false });

export const getGenreList = (axios, terms = "", letter = "") => {
  if (terms !== "") {
    let data = {
      genre_search: terms,
    };
    return axios.post(`${urlGenre}/search?genre_search=${terms}`, data);
  }
  if (letter !== "") {
    return axios.get(`${urlGenre}/starts/${letter}`);
  }
};
export const getGenreStartsWith = (axios, letter) => axios.get(`${urlGenre}/starts/${letter}`);
export const getGenreStartsWithOfficial = (axios, letter) => axios.get(`${urlGenre}/starts/${letter}/official`);
export const getGenreSearchResults = (axios, terms) => axios.post(`${urlGenre}/search`, { genre_search: terms });
export const getTrackGenres = (axios, trackId) => axios.get(`${urlGenre}/track/${trackId}`);
export const addAdditionalGenreToTrack = (axios, genreId, trackId) =>
  axios.post(`${urlGenre}/track/add`, { 'genre_id': genreId, 'track_id': trackId }, getAuthHeader());
export const getTopGenres = (axios) => axios.get(`${base}/tracks/top/genres`);
export const getSomePopularGenres = (axios) => axios.get(`${base}/tracks/genres/find/popular`);
export const getRecentGenres = (axios) => axios.get(`${base}/tracks/recent/genres`);
export const getShuffleTracks = (axios, genreIds, page = 1, perPage = 20) =>
  axios.post(`${base}/tracks/shuffle`, { genre_ids: genreIds, page, per_page: perPage });

/**
 *
 * http://www.dreamchimney.com/api/tracks/genre/starts/a
 * http://www.dreamchimney.com/api/tracks/genre/starts/z/official
 *
 * http://www.dreamchimney.com/api/tracks/genre/search/certified?genre_search=groove
 */
